






























import Vue from 'vue';
import { mapActions } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    methods: {
        ...mapActions('bh-quest-hooks', { addQuestHooks: 'create', refreshLists: 'find' })
    },
    components: {
        
    }
})
export default class QuestListsTable extends Vue {

    @Prop({ default() { return null; } })
    item!: Record<string, any>;

    dialogAddQuestAction = false;
    dialogAddQuestActionLoading = false;
    addQuestHooks: any;
    refreshLists: any;

    form = {
        atomic_action: this.item ? this.item.atomic_action : null,
        base_value_x_action: this.item ? this.item.base_value_x_action : null,
        quest_bonus: this.item ? this.item.quest_bonus : null,
        quest_multiplyer: this.item ? this.item.quest_multiplyer : null,
        est_diff_lev: this.item ? this.item.est_diff_lev : null,
        est_time: this.item ? this.item.est_time : null,
        amount_min_max_single: this.item ? this.item.amount_min_max_single : null,
        amount_min_max_weekly: this.item ? this.item.amount_min_max_weekly : null,
        amount_min_max_monthly: this.item ? this.item.amount_min_max_monthly : null,
        api_hook: this.item ? this.item.api_hook : null,
        method_hook: this.item ? this.item.method_hook : 'create',
        message: this.item ? this.item.message : null
    };

    public async addQuestAction() {
        try {
            this.dialogAddQuestActionLoading = true;
            if(!this.item) {
                await this.addQuestHooks(this.form);
            } else {
                this.item.atomic_action = this.form.atomic_action;
                this.item.base_value_x_action = this.form.base_value_x_action;
                this.item.quest_bonus = this.form.quest_bonus;
                this.item.quest_multiplyer = this.form.quest_multiplyer;
                this.item.est_diff_lev = this.form.est_diff_lev;
                this.item.est_time = this.form.est_time;
                this.item.amount_min_max_single = this.form.amount_min_max_single;
                this.item.amount_min_max_weekly = this.form.amount_min_max_weekly;
                this.item.amount_min_max_monthly = this.form.amount_min_max_monthly;
                this.item.api_hook = this.form.api_hook;
                this.item.method_hook = this.form.method_hook;
                this.item.message = this.form.message;
                this.item.patch();
            }
            await this.refreshLists();
            this.$emit('success');
            this.dialogAddQuestAction = false;
            
            if(!this.item) {
                this.form.atomic_action = null;
                this.form.base_value_x_action = null,
                this.form.quest_bonus = null;
                this.form.quest_multiplyer = null;
                this.form.est_diff_lev = null;
                this.form.est_time = null;
                this.form.api_hook = null;
                this.form.message = null;
            }

        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.dialogAddQuestActionLoading = false;
        }
    }

    public servicesFilter(items: any[]) {
        return [
            '@completed',
            'authentication',
            ...items.map(i => i.id).filter(service => [
                'logic-control',
                'cities',
                'countries',
                'regions',
                'logic-control-category',
                'bh-app-error-log',
                'bh-app-version',
                'bh-exp-tables',
                'access-control-services',
                'bh-user-obtained-exp',
                'bh-exp-hooks'
            ].indexOf(service) === -1)
        ];
    }
}
